import * as React from "react";
import { observer, inject } from "mobx-react";

interface SelectCheckboxProps {
	checked: boolean;
	disabled: boolean;
	onClick?: (e: React.MouseEvent<any>) => void;
}

@observer
export class SelectCheckbox extends React.Component<SelectCheckboxProps, {}> {
	render() {
		return <div className="selectCheckbox" onClick={this.props.onClick}>
			<label className="custom-radiocheck">
				<input type="checkbox" checked={this.props.checked} disabled={this.props.disabled} />
				<span className="checkbox-style"></span>
			</label>
		</div>
	}
}